export default "__VITE_PUBLIC_ASSET__ff07090d__"